/**
 * バリアフリーページ省略
 */
!function(){
	
	var $toggle = $('.js-barrierfree-toggle');
	if($toggle.length === 0) return false;
	$toggle.each(function(){
		var $toggle_body = $(this).find('.js-barrierfree-toggle__body');
		var $items = $toggle_body.children();
		if($items.length === 0) return false;
		var $item_clone = $items.eq(0).clone();
		$toggle_body.before($('<ul class="barrierfree-list__body">').html($item_clone));
		$items.eq(0).remove();
	});

	var btnClass = '.js-barrierfree-toggle__btn';
	$(document).on('click',btnClass,function(){
		var $btn = $(this);
		var $parent = $btn.closest('.js-barrierfree-toggle');
		var $body = $parent.find('.js-barrierfree-toggle__body');

		$btn.toggleClass('_open');
		$body.slideToggle();
	});
}();